import { render, staticRenderFns } from "./PermissionSettings.vue?vue&type=template&id=c1fad554&scoped=true"
import script from "./PermissionSettings.vue?vue&type=script&lang=js"
export * from "./PermissionSettings.vue?vue&type=script&lang=js"
import style0 from "./PermissionSettings.vue?vue&type=style&index=0&id=c1fad554&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1fad554",
  null
  
)

export default component.exports